import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import { getSvgColoredIconCss } from "@styles/common-styles";
import { PALETTE_VARS } from "@styles/palette-vars";
/**
 * Shows a single line in the user more info menu.
 * For example used to show the role of the user.
 */
export function UserMoreInfoMenuItem(t0) {
  const $ = _c(11);
  const {
    text,
    icon
  } = t0;
  const Icon = icon;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      height: "40px",
      display: "flex",
      alignItems: "center"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      width: "42px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      ...getSvgColoredIconCss(PALETTE_VARS.text.secondary),
      height: "18px",
      width: "18px"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== Icon) {
    t4 = <Box component="div" sx={t2}><Icon sx={t3} /></Box>;
    $[3] = Icon;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      fontSize: "12px",
      color: "text.secondary"
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== text) {
    t6 = <Box component="div" sx={t5}>{text}</Box>;
    $[6] = text;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t6) {
    t7 = <Box component="div" sx={t1}>{t4}{t6}</Box>;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}